module.exports = __webpack_public_path__ + "static/media/Gary E. Johnson - 2012.c1b9cad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Gary E. Johnson - 2012.jpg
// module id = 466
// module chunks = 0